import * as React from "react";
import {
  Box,
  Grid,
  Button,
  FormControl,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
  Modal,
  Fade, // Import the Fade component
  Backdrop,
  MenuItem,
} from "@mui/material";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import { postJsonData } from "../network/ApiController";
import Loader from "../component/loading-screen/Loader";
import { primaryColor, getEnv } from "../theme/setThemeColor";
import { useState, useEffect, useContext } from "react";
import { PATTERNS } from "../utils/ValidationUtil";
import ModalHeader from "../modals/ModalHeader";
import ModalFooter from "../modals/ModalFooter";
import AuthContext from "../store/AuthContext";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import VerifyOtpLogin from "../modals/VerifyOtpLogin";
import { outletRegImg } from "../iconsImports";
import useCommonContext from "../store/CommonContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "80%", md: "60%", lg: "50%" },
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 4,
  borderRadius: "12px",
  overflowY: "auto",
  maxHeight: "90vh",
};

const NewOutletAeps1 = ({ refresh, btn, autoOpen = false }) => {
  const [open, setOpen] = useState(false);
  const [isConsent, setIsConsent] = useState(false);
  const [isValMob, setIsValMob] = useState(true);
  const [request, setRequest] = useState(false);
  const [initiateData, setInitiateData] = useState();
  const [secureValidate, setSecureValidate] = useState("");
  const [otpRef, setOtpRef] = useState("");
  const [tempData, setTempData] = useState();
  const user = useContext(AuthContext);
  const userLat = user.location.lat && user.location.lat;
  const userLong = user.location.long && user.location.long;
  const envName = getEnv();
  const { refreshUser } = useCommonContext();
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setIsValMob(true);
    setIsConsent(false);
  };

  const outletRegistration = (event) => {
    event?.preventDefault();

    // FORM KO ID SE PAKAD
    const form = document.getElementById("outletRegistration");

    let data;

    if (!tempData) {
      data = {
        mobile: form.mobile.value,
        name: form.name.value,
        email: form.emailId.value,
        pan: form.pan.value,
        aadhaar: form.aadhaar.value,
        dateOfBirth: form.dateOfBirth.value,
        gender: form.gender.value,
        address: {
          city: form.city.value,
          pincode: form.pincode.value,
          full: form.fullAddress.value,
        },
        latitude: userLat,
        longitude: userLong,
      };
    } else {
      data = tempData;
    }

    console.log("FINAL PAYLOAD =>", data);

    setTempData(data);

    postJsonData(
      ApiEndpoints.AEPS1_MINEKYC,
      data,
      setRequest,
      (res) => {
        setInitiateData(res?.data?.data);
        // setOtpRef(res?.data?.data?.otpReferenceID);
        // setSecureValidate("OTP");
        okSuccessToast(res?.data?.message);
        refreshUser();
        handleClose();
        if (refresh) refresh();
      },
      (error) => apiErrorToast(error),
    );
  };

  useEffect(() => {
    if (autoOpen) setOpen(true);
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      {btn ? (
        <span onClick={handleOpen}>{btn}</span>
      ) : (
        <Box
          className=" outletRegBox"
          sx={{
            mt: -20,
            backgroundColor: "#1a78f20a", // Light purple background similar to the image
            borderRadius: "15px",
          }}
        >
          <Grid
            item
            md={12}
            xs={12}
            sx={{
              px: 10,
              py: 2,
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <InfoOutlinedIcon sx={{ fontSize: "3rem" }} />
            <Typography sx={{ fontSize: "30px", color: "#262525", mt: 2 }}>
              Complete Your Registration to Unlock Full Access
            </Typography>
            <Box sx={{ mt: -5 }}>
              <img src={outletRegImg} alt="outletRegImg" width={500} />
            </Box>

            <Button
              variant="contained"
              sx={{
                fontSize: "15px",
                background: primaryColor(),
                px: 5,
                mt: -3,
              }}
              onClick={handleOpen}
            >
              Outlet Registration
            </Button>
          </Grid>
        </Box>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop} // Use default Backdrop
        BackdropProps={{
          timeout: 500, // Adjust the duration of the transition if needed
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Loader loading={request} />
            <ModalHeader
              title="Outlet Registration"
              handleClose={handleClose}
            />
            <Box
              component="form"
              id="outletRegistration"
              autoComplete="off"
              onSubmit={outletRegistration}
              sx={{
                "& .MuiTextField-root": { m: 1 },
                mt: 2,
              }}
            >
              <Grid container spacing={2}>
                {/* Mobile */}
                <Grid item xs={12} sm={6}>
                  <FormControl sx={{ width: "100%" }}>
                    <TextField
                      autoComplete="off"
                      label="Mobile Number"
                      id="mobile"
                      size="small"
                      required
                      helperText={!isValMob ? "Invalid mobile number" : ""}
                      error={!isValMob}
                      onChange={(e) => {
                        setIsValMob(PATTERNS.MOBILE.test(e.target.value));
                        if (e.target.value === "") setIsValMob(true);
                      }}
                      inputProps={{ maxLength: 10, minLength: 10 }}
                    />
                  </FormControl>
                </Grid>

                {/* Full Name */}
                <Grid item xs={12} sm={6}>
                  <FormControl sx={{ width: "100%" }}>
                    <TextField
                      autoComplete="off"
                      label="Full Name"
                      id="name"
                      size="small"
                      required
                    />
                  </FormControl>
                </Grid>

                {/* Email */}
                <Grid item xs={12} sm={6}>
                  <FormControl sx={{ width: "100%" }}>
                    <TextField
                      autoComplete="off"
                      label="Email ID"
                      id="emailId"
                      size="small"
                      required
                    />
                  </FormControl>
                </Grid>

                {/* PAN */}
                <Grid item xs={12} sm={6}>
                  <FormControl sx={{ width: "100%" }}>
                    <TextField
                      autoComplete="off"
                      label="PAN"
                      id="pan"
                      size="small"
                      required
                      inputProps={{ maxLength: 10 }}
                    />
                  </FormControl>
                </Grid>

                {/* Aadhaar */}
                <Grid item xs={12} sm={6}>
                  <FormControl sx={{ width: "100%" }}>
                    <TextField
                      autoComplete="off"
                      label="Aadhaar"
                      id="aadhaar"
                      size="small"
                      required
                      inputProps={{ maxLength: 12 }}
                    />
                  </FormControl>
                </Grid>

                {/* DOB */}
                <Grid item xs={12} sm={6}>
                  <FormControl sx={{ width: "100%" }}>
                    <TextField
                      type="date"
                      id="dateOfBirth"
                      size="small"
                      required
                    />
                  </FormControl>
                </Grid>

                {/* Gender */}
                <Grid item xs={12} sm={6}>
                  <FormControl sx={{ width: "100%" }}>
                    <TextField
                      select
                      label="Gender"
                      id="gender"
                      name="gender"
                      size="small"
                      defaultValue="M"
                      required
                      SelectProps={{
                        native: false,
                      }}
                    >
                      <MenuItem value="M">Male</MenuItem>
                      <MenuItem value="F">Female</MenuItem>
                      <MenuItem value="O">Others</MenuItem>
                    </TextField>
                  </FormControl>
                </Grid>

                {/* City */}
                <Grid item xs={12} sm={6}>
                  <FormControl sx={{ width: "100%" }}>
                    <TextField
                      autoComplete="off"
                      label="City"
                      id="city"
                      size="small"
                      required
                    />
                  </FormControl>
                </Grid>

                {/* Pincode */}
                <Grid item xs={12} sm={6}>
                  <FormControl sx={{ width: "100%" }}>
                    <TextField
                      autoComplete="off"
                      label="Pincode"
                      id="pincode"
                      size="small"
                      required
                      inputProps={{ maxLength: 6 }}
                    />
                  </FormControl>
                </Grid>

                {/* Full Address */}
                <Grid item xs={12}>
                  <FormControl sx={{ width: "100%" }}>
                    <TextField
                      autoComplete="off"
                      label="Full Address"
                      id="fullAddress"
                      size="small"
                      required
                      multiline
                      rows={3}
                    />
                  </FormControl>
                </Grid>

                {/* Consent */}
                <Grid item xs={12}>
                  <FormControlLabel
                    size="small"
                    control={
                      <Checkbox
                        sx={{
                          color: primaryColor(),
                          "&.Mui-checked": { color: primaryColor() },
                        }}
                        checked={isConsent}
                        onClick={() => setIsConsent(!isConsent)}
                      />
                    }
                    label={
                      <Typography sx={{ fontSize: "0.75rem" }}>
                        I hereby give my consent and submit voluntarily at my
                        own discretion, my Aadhaar Number or VID for the purpose
                        of establishing my identity on the portal.
                      </Typography>
                    }
                  />
                </Grid>
              </Grid>
            </Box>
            <ModalFooter
              form="outletRegistration"
              primaryActionLabel="Continue"
              onPrimaryAction={outletRegistration}
              secondaryActionLabel="Cancel"
              onSecondaryAction={handleClose}
              disable={request || !isConsent}
            />
          </Box>
        </Fade>
      </Modal>

    </Box>
  );
};

export default NewOutletAeps1;
